import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import LiveClassesCalendar from './LiveClassesCalendar';
import LiveClassesHighlights from './LiveClassesHighlights';
import LiveClassSurvey from '../LiveClassSurvey';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import { DashboardContent } from '@/layouts/dashboard';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { TypewriterText } from '@/components/custom/typewriter-text';
import tiaAula from '@/assets/images/tia/TIA-AULA.png';

const PLAYFUL_TAB_CLASSNAME = 'data-[state=active]:bg-[var(--color-mission)] data-[state=active]:text-white data-[state=active]:font-extrabold data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)] data-[state=active]:-translate-y-px';

function LiveClassesPlayful({ uri }) {
  const isStudent = useCheckIncludeProfiles({ only: ['student'] });
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') === 'calendario' ? 'calendario' : 'destaque';
  const handleTabChange = value => setSearchParams({ tab: value });

  const [weekDays, setWeekDays] = useState([]);

  const [notAnsweredSurveys, setNotAnsweredSurveys] = useState([]);
  const [currentSurvey, setCurrentSurvey] = useState(0);

  const breadCrumbs = {
    title: 'Cursos e Aulas',
    nav: [
      {
        route: uri,
        name: 'Aulas ao vivo',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadCrumbs}
    >
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
      >
        <div
          className="relative mb-6 mt-16 flex items-center rounded-[24px] p-4 pl-[170px] shadow-card"
          style={{ background: 'var(--color-bg-lilac)' }}
        >
          <img
            src={tiaAula}
            alt="T.I.A"
            className="pointer-events-none absolute bottom-0 left-2 z-10 h-[180px] w-auto object-contain object-bottom"
          />
          <div className="relative z-10 max-w-[520px] rounded-[16px] rounded-bl-none bg-white p-4 shadow-card">
            <span
              className="block text-xs font-extrabold"
              style={{ color: 'var(--color-secondary-dark)' }}
            >
              T.I.A
            </span>
            <p
              className="mb-0 text-sm font-bold leading-relaxed"
              style={{ color: '#222731' }}
            >
              <TypewriterText text={'Sua programação de Aulas ao Vivo está aqui! Toque no card para entrar e boa aula! Se tiver dúvida, escreve no chat que a turma te ajuda. 🤜🤛'} />
            </p>
          </div>
          <div className="relative z-10 ml-auto mr-2 shrink-0">
            <TabsList className="border border-neutral-lighter bg-white">
              <TabsTrigger
                value="destaque"
                className={PLAYFUL_TAB_CLASSNAME}
              >
                Destaques
              </TabsTrigger>
              <TabsTrigger
                value="calendario"
                className={PLAYFUL_TAB_CLASSNAME}
              >
                Calendário
              </TabsTrigger>
            </TabsList>
          </div>
        </div>

        <TabsContent value="destaque">
          <LiveClassesHighlights />
        </TabsContent>

        <TabsContent value="calendario">
          <LiveClassesCalendar
            weekDays={weekDays}
            setWeekDays={setWeekDays}
            setNotAnsweredSurveys={setNotAnsweredSurveys}
          />
        </TabsContent>
      </Tabs>

      {isStudent && notAnsweredSurveys.length > 0 && notAnsweredSurveys?.[currentSurvey] && (
        <LiveClassSurvey
          setCurrentSurvey={setCurrentSurvey}
          liveClassId={notAnsweredSurveys?.[currentSurvey]?.id}
          liveClassName={notAnsweredSurveys?.[currentSurvey]?.title}
        />
      )}
    </DashboardContent>
  );
}

export default LiveClassesPlayful;
